/* eslint-disable @typescript-eslint/no-unused-vars */
import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { TenantMutator } from '@/lib/entity/tenant'
import type { Converter } from '@/lib/converter/entityFormatter'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type TenantSchema = TenantMutator['merged']

export const TenantConverter: Converter<TenantSchema> = {
  icon: () => i18next.t('stages.icon.setting'),
  title: () => i18next.t('stages.table.setting'),
  subTitle: async () => i18next.t('ui.common.inputting'),
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.setting.${column}`)
    return match(column)
      .with('settings', (column) => asModifiedField(label, modified.settings))
      .with('id', () => undefined)
      .exhaustive()
  }
}
